import React from 'react';

import { useFormContext } from 'react-hook-form';

import { FormValues } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.types';
import classes from 'components/Dashboards/Reporting/ReportSettingsModal/components/UpdateReportTags/UpdateReportTags.module.scss';
import { optionsToTags } from 'components/Dashboards/Reporting/ReportSettingsModal/components/UpdateReportTags/UpdateReportTags.utils';
import { ReportTagsSelectWithCreate } from 'components/Dashboards/Reporting/_common/ReportTagsSelectWithCreate/ReportTagsSelectWithCreate';

export const UpdateReportTags = () => {
    const { control, setValue } = useFormContext<FormValues>();

    const handleChange = (value: ISelectOption<number>[]) => {
        const selectedTags = optionsToTags(value);
        setValue('selectedTags', selectedTags, { shouldDirty: true });
    };

    return (
        <div className={classes.tags}>
            <label>Tags: </label>
            <div className={classes.tagsSelect}>
                <ReportTagsSelectWithCreate control={control} handleChange={handleChange} />
            </div>
        </div>
    );
};
